import axios from 'axios';
import { authInterceptor, logout } from './auth-interceptor';

const voiceAgentService = import.meta.env.VITE_VOICE_AGENT_URL;

export const voiceAgentHttp = axios.create({
  baseURL: `${voiceAgentService}/api/v1`,
  withCredentials: true,
});

voiceAgentHttp.interceptors.response.use((result) => result.data);

authInterceptor(voiceAgentHttp, {
  getAccessToken: () => localStorage.getItem('apiv1Auth'),
  shouldLogout: (error) => {
    const status = error?.response?.status;
    const errorCode = error?.response?.data?.error;
    if (errorCode === 'err_token_expired') return false;
    return (
      status === 401 ||
      ['err_user_deleted', 'err_suspended'].includes(errorCode)
    );
  },
  shouldRefresh: (error) =>
    error?.response?.data?.error === 'err_token_expired',
  logout: logout,
});
